export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00943.a429ba8b.png";